import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-core-php-dev',
  templateUrl: './custom-core-php-dev.component.html',
  styleUrls: ['./custom-core-php-dev.component.css']
})
export class CustomCorePhpDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/custom-core-php-dev/custom-core-php-dev.component.ts